class Badges{
    constructor(headers){
        this.headers=headers;
    }
    async get(pid,branch,scores,reportUuid=null){
        let url =`/api/v2/badges/${pid}/$domain$?branch=${window.cleanEncodeURIComponent(branch)}&b64&slug=${Date.now()}`
        if(reportUuid) url+="&reportUuid="+reportUuid
        const securityBadge = await this.loadImage(url.replace("$domain$","security").replace("$score$",scores.security));
        const stabilityBadge = await this.loadImage(url.replace("$domain$","stability").replace("$score$",scores.stability));
        const licensingBadge = await this.loadImage(url.replace("$domain$","licensing").replace("$score$",scores.licensing))
        return {
            securityBadge, stabilityBadge, licensingBadge
        }

    }
    async loadImage(url){
        try{
            return await new Promise(async(resolve, reject)=>{
                setTimeout(reject,3*1000);
                const data= await fetch(url,{ headers:this.headers});
                if(data.status!==200) throw new Error("Badge not available")
                const svg= await data.text();
                resolve(this.asEmbeddedImage(svg));
            })
        }
        catch(e){
            return null
        }
    }
    asEmbeddedImage(svgImageString){
        var encoded = svgImageString.replace(/\n+/g, '');
        encoded = window.cleanEncodeURIComponent(encoded)
            .replace(/%20/g, ' ')
            .replace(/%3D/g, '=')
            .replace(/%3A/g, ':')
            .replace(/%2F/g, '/')
            .replace(/%22/g, "'");

        return 'data:image/svg+xml,' + encoded;
    }
}

export default Badges